import React from 'react';
import { KPICard, LoadingSpinner } from '../../ui';
import { formatNumber } from '../../../utils/formatters';
import { useRefineCustomerComplaintStatus } from '../../../hooks/useRefineCustomerQueries';

import { KPIProps } from '../../../types/kpi';
const ComplaintReviewKPI: React.FC<KPIProps> = ({
  branchId = 0,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data: complaintStatus, isLoading, error, refetch } = useRefineCustomerComplaintStatus(branchId);

  React.useEffect(() => {
    if (error && onError) {
      onError(error as Error);
    }
  }, [error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (error || !complaintStatus) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری وضعیت شکایات</p>
        {showLoading && (
          <button
            onClick={() => refetch()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  const totalComplaints = (complaintStatus?.reviewed || 0) + (complaintStatus?.notReviewed || 0);
  const reviewedPercentage = totalComplaints > 0
    ? ((complaintStatus?.reviewed || 0) / totalComplaints * 100).toFixed(1)
    : '0';

  return (
    <div className={`${className} animate-enter-up stagger-4`}>
      <KPICard
        title="بررسی شکایات"
        value={`${reviewedPercentage}%`}
        subtitle={`${formatNumber(complaintStatus?.reviewed || 0)} از ${formatNumber(totalComplaints)}`}
        variant="warning"
        accentStyle="corner"
      />
    </div>
  );
};

export default ComplaintReviewKPI;